/**
 * Created by sange on 30/09/2017.
 */
import { Injectable } from '@angular/core'
import { CanActivate } from '@angular/router'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs/Observable'
import { of } from 'rxjs/observable/of'
import { catchError, switchMap } from 'rxjs/operators'

import { AppState } from '../../../store'
import * as fromStore from '../store'

import { getFromStoreOrAPI } from '../../utils/helpers'

@Injectable()
export class TeamsGuard implements CanActivate {

  constructor(private store: Store<AppState>) {
  }

  canActivate(): Observable<boolean> {
    return getFromStoreOrAPI({
      store: this.store,
      action: new fromStore.LoadTeams(),
      selector: fromStore.getTeamsSelector
    }).pipe(
      switchMap(() => of(true)),
      catchError(() => of(false)))
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/team/guards/teams.guard.ts